// import { put } from 'redux-saga/effects';
// import { getErrorActionName } from './util/util';

//import { makeSelectUsername } from 'view.updater/selectors/home.selectors'; 
export default function* allAfterErrorMiddleware(action) {
    switch (action.type) {
        default:
            return;
    }
}